var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKfaTwoTop60Bottom40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "108px",
    viewBox: "0 0 144 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kfa-two-top60-bottom40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content-Structure---Phase-2---Dev-Frozen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.5---Key-Focus-Area-detail---DT.DM_v1",
    transform: "translate(-1192.000000, -296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout-Thumbnails",
    transform: "translate(1024.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kfa-two-top60-bottom40",
    transform: "translate(168.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bkgrd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "White",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 144,
    height: 108
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bkgrd-Elements",
    transform: "translate(0.000000, 8.074766)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DEDEDE",
    x: 0,
    y: 0,
    width: 144,
    height: 18.1682243
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#979797",
    x: 0.5,
    y: 0.5,
    width: 2.10791367,
    height: 17.1682243
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DEDEDE",
    x: 0,
    y: 18.1682243,
    width: 3.10791367,
    height: 81.7570093
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(9.000000, 33.000000)",
    fill: "#DEDEDE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 0,
    width: 57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 10,
    width: 57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 20,
    width: 57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 30,
    width: 57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 40,
    width: 57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 0,
    y: 50,
    width: 57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 0,
    y: 60,
    width: 57,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(10.215827, 14.130841)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 35.7553957,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 31.9244604,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 29.881295,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 28.8597122,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 25.794964,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 22.9856115,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F4F",
    x: 0,
    y: 0,
    width: 18.5161871,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 16.0899281,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 6.76798561,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 5.74640288,
    height: 4.03738318
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F4F",
    x: 0,
    y: 0,
    width: 4.34172662,
    height: 4.03738318
  })), /*#__PURE__*/React.createElement("g", {
    id: "Areas",
    transform: "translate(70.848921, 79.738318)",
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 64,
    height: 20.1869159
  })), /*#__PURE__*/React.createElement("g", {
    id: "Areas",
    transform: "translate(70.848921, 33.308411)",
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 64,
    height: 41.3831776
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKfaTwoTop60Bottom40);
export default __webpack_public_path__ + "static/media/kfa-two-top60-bottom40.2e82d5af6e44e0666c421e49dc0fda96.svg";
export { ForwardRef as ReactComponent };